import React from "react";
import { useAppContext } from "../context/ContextProvider";
import firebaseApp from "../index";
import { getFirestore, updateDoc, doc } from "firebase/firestore";

const AgregarTarea = ({ setArrayTareas, arrayTareas }) => {
    const { correoUsuario } = useAppContext();
    const firestore = getFirestore(firebaseApp);

    async function añadirTarea(e) {
        e.preventDefault();
        const descripcion = e.target.formDescripcion.value;
        const vencimiento = e.target.formVencimiento.value;
        // crear nuevo array de tareas
        const nvoArrayTareas = [
            ...arrayTareas,
            {
                id: +new Date(),
                descripcion: descripcion,
                vencimiento: vencimiento,
            },
        ];
        // actualizar base de datos
        const docuRef = doc(firestore, `usuarios/${correoUsuario}`);
        updateDoc(docuRef, { tareas: [...nvoArrayTareas] });
        //actualizar estado
        setArrayTareas(nvoArrayTareas);
        // limpiar form
        e.target.formDescripcion.value = "";
    }
    return (
        <div>
            <form
                onSubmit={añadirTarea}
                className="flex items-center justify-center"
            >
                <input
                    required
                    type="text"
                    id="formDescripcion"
                    name="formDescripcion"
                    placeholder="Describe tu tarea"
                    className="w-full py-3 px-2 rounded text-black focus:outline-none"
                />
                <div class="flex items-center justify-center">
                    <label for="formVencimiento" class="text-white px-1">
                        Vencimiento:
                    </label>
                    <input
                        type="date"
                        id="formVencimiento"
                        name="formVencimiento"
                        placeholder="Fecha de vencimiento"
                        className="form-control block px-3 w-44 py-3 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    />
                </div>

                <button
                    type="submit"
                    className="flex-shrink-0 text-white bg-indigo-500 border-0 p-2 m-2 w-10 focus:outline-none hover:bg-indigo-600 rounded text-lg"
                >
                    +
                </button>
            </form>
        </div>
    );
};

export default AgregarTarea;
